import { Send } from "lucide-react";
import BeforeAfterSlider from "./BeforeAfterSlider";
import { useLanguage } from "../context/LanguageContext";

export default function AiPreviewResult({
  beforeSrc,
  afterSrc,
  onRetry,
  isGenerating,
}) {
  const { t } = useLanguage();

  const goToEstimate = () => {
    window.location.assign("/?ai-preview-photo=1#contact");
  };

  return (
    <div className="max-w-full min-w-0 space-y-5 overflow-hidden">
      <div className="relative max-w-full overflow-hidden">
        <BeforeAfterSlider
          beforeSrc={beforeSrc}
          afterSrc={afterSrc}
          alt={t("aiPreview.result.alt")}
          showAfterLogo
        />
      </div>

      <div className="flex max-w-full flex-col gap-4 rounded-2xl border border-slate-200 bg-white/80 p-4 dark:border-white/10 dark:bg-white/5 sm:flex-row sm:items-center sm:justify-between sm:rounded-3xl sm:p-5">
        <div className="min-w-0">
          <h2 className="text-lg font-bold text-slate-900 dark:text-white">
            {t("aiPreview.result.conversionTitle")}
          </h2>
          <p className="mt-1 text-sm leading-relaxed text-slate-600 dark:text-white/65">
            {t("aiPreview.result.conversionText")}
          </p>
          <p className="mt-2 text-xs leading-relaxed text-slate-500 dark:text-white/45">
            {t("aiPreview.result.note")}
          </p>
        </div>
        <div className="flex w-full max-w-full flex-col items-stretch gap-2 sm:w-auto sm:items-end">
          <button
            type="button"
            onClick={goToEstimate}
            className="inline-flex min-h-11 max-w-full items-center justify-center gap-2 rounded-full bg-[#66C95E] px-5 py-3 text-center text-sm font-semibold leading-snug text-white shadow-sm transition hover:bg-[#58B551]"
          >
            <Send size={17} />
            {t("aiPreview.result.cta")}
          </button>
          <button
            type="button"
            onClick={onRetry}
            disabled={isGenerating}
            className="min-h-11 self-center border-0 bg-transparent px-1 py-2 text-xs font-medium leading-snug text-slate-400 underline-offset-4 transition hover:text-slate-500 hover:underline disabled:cursor-not-allowed disabled:opacity-50 dark:text-white/35 dark:hover:text-white/50 sm:self-end"
          >
            {t("aiPreview.result.retry")}
          </button>
        </div>
      </div>
    </div>
  );
}
